import { render } from "./Index.vue?vue&type=template&id=6013c15e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=6013c15e&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=6013c15e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src130321472/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6013c15e"]])

export default __exports__